module.exports = __webpack_public_path__ + "img/derby_1920.804e9c5a.png";